import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ImageGallery from "react-image-gallery";
import Carousel from "react-elastic-carousel";
import "./../styles/SantralPage.scss";
import ruzgarpng from "./../img/ruzgarpng.png";
import hidropng from "./../img/hidropng.png";
import jeopng from "./../img/jeopng.png";
import gunespng from "./../img/gunespng.png";
import mappng from "./../img/mappng.png";
import ruzgarinpng from "./../img/ruzgarinpng.png";
import hibritpng from './../img/hibritpng.png';
import okcopy from "../img/okcopy.png";
import Lottie from "react-lottie";
import ruzgaranimation from "../img/ruzgaranimation.json";
import hidroanimation from "../img/hidroanim.json";
import sunanimation from "../img/sunanim.json";
import jeoanimation from "../img/jeoanim.json";
import hibritanimation from "../img/hibritanimation.json";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Api from "../common/api";
import { toBePartiallyChecked } from "@testing-library/jest-dom/dist/matchers";

const SantralPage = () => {

  const lang = localStorage.getItem("lang");
  const [tabs, setTabs] = useState([
    {
      id: 0,
      Name_TR: "Tüm Santraller",
      Name_EN: "All Plants",
      Capacity: 0,
      show: false
    },
    {
      id: 1,
      Name_TR: "Rüzgar",
      Name_EN: "Wind",
      image: ruzgarpng,
      content: [],
      Capacity: 0,
      show: false
    },
    {
      id: 2,
      Name_TR: "Hidroelektrik",
      Name_EN: "Hydroelectric",
      image: hidropng,
      content: [],
      Capacity: 0,
      show: false
    },
    {
      id: 3,
      Name_TR: "Jeotermal",
      Name_EN: "Geothermal",
      image: jeopng,
      content: [],
      Capacity: 0,
      show: false
    },
    {
      id: 4,
      Name_TR: "Güneş",
      Name_EN: "Solar",
      image: gunespng,
      content: [],
      Capacity: 0,
      show: false
    },
    {
      id: 5,
      Name_TR: "Hibrit",
      Name_EN: "Hybrid",
      image: hibritpng,
      content: [],
      Capacity: 0.0,
      show: false
    },
  ]);

  const [windTabsInfo, setWindTabsInfo] = useState([
    {
      id: 1,
      location: "Çatalca-İstanbul",
      watt: "93 MW",
      yearenergy: "286 Milyon kWh",
      tarih: "Aralık 2016",
      co2: "240,000 ton/yıl",
      hane: "115.000",
      certificate: "Gold Standart",
    },
  ]);

  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[2]
  );
  const [content, setContent] = useState();

  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const [currentTabId, setCurrentTabId] = useState(tabs[0].id);
  const [currentSubTab, setCurrentSubTab] = useState([]);
  const [currentSubTabId, setCurrenSubTabId] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isStopped, setIsStopped] = useState(true);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [selectedTitle, setTitle] = useState([]);

  React.useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 600 });
    
    Api.get("/centrals/list").then((res) => {
      tabs.forEach((tab) => {
        tab.Capacity = 0;
      });
      res.data.items.forEach((item) => {
        tabs.forEach((tab) => {
          if (tab.id === 0) tab.Capacity += parseFloat(item.Capacity);
          
          if (tab.id === item.Category) {
            tab.content.push(item);
            tab.Capacity += parseFloat(item.Capacity);
          }
        });
      });

      setTabs(tabs);
      adClick(tabs[0].id, tabs[0].Name_TR);

      //console.log("First Load");
      //console.log(tabs);
    });
  }, []);

  const [breakPoints, setBreakPoints] = useState([
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2 },
    { width: 850, itemsToShow: 4 },
    { width: 660, itemsToShow: 3, itemsToScroll: 3 },
    { width: 900, itemsToShow: 4, itemsToScroll: 2 },
    { width: 1450, itemsToShow: 5 },
    { width: 1750, itemsToShow: 6 },
  ]);

  const adClick = (id, name) => {
    var newTabs = [];
    tabs.forEach((selItem) => {
      if (selItem.id == id) {
        newTabs.push({
          id: selItem.id,
          Name_TR: selItem.Name_TR,
          Name_EN: selItem.Name_EN,
          content: selItem.content,
          image: selItem.image,
          Capacity: selItem.Capacity,
          show: true
        });
      }
      else {
        newTabs.push({
          id: selItem.id,
          Name_TR: selItem.Name_TR,
          Name_EN: selItem.Name_EN,
          content: selItem.content,
          image: selItem.image,
          Capacity: selItem.Capacity,
          show: false
        });
      }
    });
    //console.log("On Clicked");
    //console.log(newTabs);
    setTabs(newTabs);
    setCurrentTabId(id);
    setCurrentTab(name);
    setIsStopped(true);
    setTimeout(() => {
      setIsStopped(false);
    }, 100);
  };

  const dropdownHandler = (id, tab) => {
    if (id == currentSubTabId) {
      setCurrenSubTabId(null);
      setImages([]);
    } else {
      setCurrenSubTabId(id);
      setImages(tab.gallery.map((a) => a.file_name));
    }
  };

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: ruzgaranimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const defaultOptionsSun = {
    loop: false,
    autoplay: true,
    animationData: sunanimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const defaultOptionsHidro = {
    loop: false,
    autoplay: true,
    animationData: hidroanimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const defaultOptionsJeo = {
    loop: false,
    autoplay: true,
    animationData: jeoanimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const defaultOptionsHybrid = {
    loop: false,
    autoplay: true,
    animationData: hibritanimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  let myRef = useRef();

  const scrollSantral = (e) => {
    if (e.id == 11)
      window.scrollTo({ behavior: "smooth", top: 1300 });
    else if (e.id == 15)
      window.scrollTo({ behavior: "smooth", top: 1350 });
    else if (e.id == 16)
      window.scrollTo({ behavior: "smooth", top: 1400 });
    else if (e.id == 13)
      window.scrollTo({ behavior: "smooth", top: 1450 });
    else if (e.id == 20)
      window.scrollTo({ behavior: "smooth", top: 1500 });
    else if (e.id == 12)
      window.scrollTo({ behavior: "smooth", top: 1550 });
    else if (e.id == 4)
      window.scrollTo({ behavior: "smooth", top: 1600 });
    else if (e.id == 6)
      window.scrollTo({ behavior: "smooth", top: 1650 });
    else if (e.id == 7)
      window.scrollTo({ behavior: "smooth", top: 1700 });
    else if (e.id == 8)
      window.scrollTo({ behavior: "smooth", top: 1750 });
    else if (e.id == 9)
      window.scrollTo({ behavior: "smooth", top: 1800 });
    else if (e.id == 10)
      window.scrollTo({ behavior: "smooth", top: 1850 });
    else if (e.id == 17)
      window.scrollTo({ behavior: "smooth", top: 1900 });
    else if (e.id == 18)
      window.scrollTo({ behavior: "smooth", top: 1950 });
    else if (e.id == 19)
      window.scrollTo({ behavior: "smooth", top: 2000 });
    else if (e.id == 21)
      window.scrollTo({ behavior: "smooth", top: 2050 });
    else if (e.id == 14)
      window.scrollTo({ behavior: "smooth", top: 2100 });
    else if (e.id == 22)
      window.scrollTo({ behavior: "smooth", top: 2150 });
    else
      window.scrollTo({ behavior: "smooth", top: 1550 });
  };

  const imageChangeHandler = (direction) => {
    if (direction === 1) {
      if (photoIndex === images.length - 1) {
        return setPhotoIndex(0);
      }
      setPhotoIndex(photoIndex + 1);
    }
    if (direction === -1) {
      if (photoIndex === 0) {
        return setPhotoIndex(images.length - 1);
      }
      setPhotoIndex(photoIndex - 1);
    }
  };

  const imgOnClickHandler = (i) => {
    setPhotoIndex(i);
    setIsOpen(true);
  };

  return (
    <>
      <div
        style={{ lineHeight: "22px", fontSize: "14px" }}
        className="top-para-div"
      >
        <div
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        ></div>
      </div>
      <div className="santral-tabs">
        {tabs
          ? tabs.map((tab) => {
              return tab.id == 0 ||
                (Array.isArray(tab.content) && tab.content.length) ? (
               
                  lang == "en" ?(
                  
                    <li
                    className={currentTab.id === tab.id ? "active-tab" : null}
                    onClick={() => adClick(tab.id, tab.Name_TR)}
                    key={tab.id}
                  >
                    <div style={{display: "inline-flex", verticalAlign: "middle", justifyContent: "center", textAlign: "center", height: "42px"}}>
                      <img src={tab.image ? tab.image : null} alt="sj" style={{marginTop: 4}} />
                      <span style={{height: "42px", margin: 0, paddingTop: "13px"}}>{tab.Name_EN}</span>
                    </div>
                    
                    <div className="powerInfo" style={{display: tab.show ? 'flex' : 'none', justifyContent: "center", height: 42, alignItems: "center", backgroundColor: "white", color: "#575757" }}>
                      <p style={{fontWeight: "bold"}}>TOPLAM</p>
                      <div className="powerInfoPipe" style={{marginLeft: "10px", marginRight: "10px", height: "22px", backgroundColor: "black", width: "2px" }}></div>
                      <p style={{fontSize: "24px", fontWeight: "bold"}}>{tab.Capacity.toFixed(1)}</p>
                      <p style={{fontWeight: "bold"}}>MW</p>
                    </div>
                  </li>
                
                ): ( 
                <li
                  className={currentTab.id === tab.id ? "active-tab" : null}
                  onClick={() => adClick(tab.id, tab.Name_TR)}
                  key={tab.id}
                >
                  <div style={{display: "inline-flex", verticalAlign: "middle", justifyContent: "center", textAlign: "center", height: "42px"}}>
                    <img src={tab.image ? tab.image : null} alt="sj" style={{marginTop: 4}} />
                    <span style={{height: "42px", margin: 0, paddingTop: "13px"}}>{tab.Name_TR}</span>
                  </div>
                  
                  <div className="powerInfo" style={{display: tab.show ? 'flex' : 'none', justifyContent: "center", height: 42, alignItems: "center", backgroundColor: "white", color: "#575757" }}>
                    <p style={{fontWeight: "bold"}}>TOPLAM</p>
                    <div className="powerInfoPipe" style={{marginLeft: "10px", marginRight: "10px", height: "22px", width: "2px" }}></div>
                    <p style={{fontSize: "24px", fontWeight: "bold"}}>{tab.Capacity.toFixed(1)}</p>
                    <p style={{fontWeight: "bold"}}>&nbsp;MW</p>
                  </div>
                </li>
                )
              ) : null;
            })
          : null}
      </div>
      <div className="santral-content-container">
        <div className="map">
          <img src={mappng} alt="map" />
          {tabs.map((tab) =>
            tab.content
              ? tab.content.map((index) => (
                  <div
                    className={"santrals wind-img santral" + index.id}
                    onClick={() => {
                      scrollSantral(index);
                      dropdownHandler(index.id, index);
                    }}
                    onMouseOver={() => setTitle(index.id)}
                    onMouseLeave={() => setTitle([])}
                  >
                    <h3
                      className={selectedTitle === index.id ? "hide" : "show"}
                    >
                      {lang =="en" ? index.Name_EN:index.Name_TR}
                    </h3>
                    {tab.Name_TR == "Rüzgar" ? (
                      currentTab == "Rüzgar" ||
                      currentTab == "Tüm Santraller" ? (
                        <Lottie
                          src={ruzgarinpng}
                          options={defaultOptions}
                          isStopped={isStopped}
                        />
                      ) : null
                    ) : tab.Name_TR == "Hidroelektrik" ? (
                      currentTab == "Hidroelektrik" ||
                      currentTab == "Tüm Santraller" ? (
                        <Lottie
                          src={hidropng}
                          options={defaultOptionsHidro}
                          isStopped={isStopped}
                        />
                      ) : null
                    ) : tab.Name_TR == "Jeotermal" ? (
                      currentTab == "Jeotermal" ||
                      currentTab == "Tüm Santraller" ? (
                        <Lottie
                          src={jeopng}
                          options={defaultOptionsJeo}
                          isStopped={isStopped}
                        />
                      ) : null
                    ) : tab.Name_TR == "Hibrit" ? (
                      currentTab == "Hibrit" ||
                      currentTab == "Tüm Santraller" ? (
                        <Lottie
                          src={hibritpng}
                          options={defaultOptionsHybrid}
                          isStopped={isStopped}
                        />
                      ) : null
                    ) : tab.Name_TR == "Güneş" ? (
                      currentTab == "Güneş" ||
                      currentTab == "Tüm Santraller" ? (
                        <Lottie
                          src={gunespng}
                          options={defaultOptionsSun}
                          isStopped={isStopped}
                        />
                      ) : null
                    ) : null}
                  </div>
                ))
              : null
          )}
        </div>
      </div>
      <div className="santral-info-container">
        <div className="only-wind-container wind">
          {currentTab == "Rüzgar" || currentTab == "Tüm Santraller"
            ? tabs.map((tab) =>
                tab.Name_TR == "Rüzgar"
                  ? tab.content.map((item) => {
                      return (
                        <>
                          <div
                            onClick={() => dropdownHandler(item.id, item)}
                            key={item.id}
                            className={
                              item.id == currentSubTabId
                                ? "downable active"
                                : "downable"
                            }
                          >
                            <div className="elec-left-section">
                              <img src={ruzgarpng} alt="sj" />
                              <h3>{lang =="en" ? item.Name_EN:item.Name_TR}</h3>
                            </div>
                            <button onClick={(id) => dropdownHandler(id, item)}>
                              <img
                                className={
                                  item.id == currentSubTabId ? "" : "flat"
                                }
                                src={okcopy}
                                alt="sj"
                              />
                            </button>
                          </div>
                          <div
                            className={
                              item.id == currentSubTabId
                                ? "wind-info active"
                                : "wind-info"
                            }
                          >
                            <div className="img-slider">
                              {item.gallery ? (
                                <>
                                  <Carousel
                                    pagination={false}
                                    focusOnSelect={true}
                                    breakPoints={breakPoints}
                                  >
                                    {item.gallery.map((img, i) => (
                                      <img
                                        onClick={() => imgOnClickHandler(i)}
                                        width="250px"
                                        src={
                                          "https://sankoenerji.com.tr/" +
                                          img.file_name.split("/Uploads/")[0] +
                                          "Uploads/thumbs/" +
                                          img.file_name.split("/Uploads/")[1]
                                        }
                                        alt={img.name}
                                      />
                                    ))}
                                  </Carousel>
                                  {isOpen && (
                                    <Lightbox
                                      mainSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[photoIndex]
                                      }
                                      nextSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[(photoIndex + 1) % images.length]
                                      }
                                      prevSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[
                                          (photoIndex + images.length - 1) %
                                            images.length
                                        ]
                                      }
                                      onCloseRequest={() => setIsOpen(false)}
                                      onMovePrevRequest={() =>
                                        imageChangeHandler(-1)
                                      }
                                      onMoveNextRequest={() =>
                                        imageChangeHandler(1)
                                      }
                                      animationDuration="100"
                                    />
                                  )}
                                </>
                              ) : null}
                            </div>
                            <div className="wind-info-box">
                              {lang =="en" ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content_EN,
                                }}
                              ></div>
                              ) : (<div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content,
                                }}
                              ></div>)}
                            </div>
                          </div>
                        </>
                      );
                    })
                  : null
              )
            : null}
        </div>
        <>
          <div className="only-wind-container hidro">
            {currentTab == "Hidroelektrik" || currentTab == "Tüm Santraller"
              ? tabs.map((tab) =>
                  tab.Name_TR == "Hidroelektrik"
                    ? tab.content.map((item) => {
                        return (
                          <>
                            <div
                              onClick={() => dropdownHandler(item.id, item)}
                              key={item.id}
                              className={
                                item.id == currentSubTabId
                                  ? "downable active hidro"
                                  : "downable"
                              }
                            >
                              <div className="elec-left-section">
                                <img src={hidropng} alt="sj" />
                                <h3>{lang =="en" ? item.Name_EN:item.Name_TR}</h3>
                              </div>
                              <button
                                onClick={(id) => dropdownHandler(id, item)}
                              >
                                <img
                                  className={
                                    item.id == currentSubTabId ? "" : "flat"
                                  }
                                  src={okcopy}
                                  alt="sj"
                                />
                              </button>
                            </div>
                            <div
                              className={
                                item.id == currentSubTabId
                                  ? "wind-info active hidro"
                                  : "wind-info"
                              }
                            >
                              <div className="img-slider">
                                {item.gallery ? (
                                  <>
                                    <Carousel
                                      pagination={false}
                                      focusOnSelect={true}
                                      breakPoints={breakPoints}
                                    >
                                      {item.gallery.map((img, i) => (
                                        <img
                                          onClick={() => imgOnClickHandler(i)}
                                          width="250px"
                                          src={
                                            "https://sankoenerji.com.tr/" +
                                            img.file_name.split(
                                              "/Uploads/"
                                            )[0] +
                                            "Uploads/thumbs/" +
                                            img.file_name.split("/Uploads/")[1]
                                          }
                                          alt={img.name}
                                        />
                                      ))}
                                    </Carousel>
                                    {isOpen && (
                                      <Lightbox
                                        mainSrc={
                                          "https://sankoenerji.com.tr/" +
                                          images[photoIndex]
                                        }
                                        nextSrc={
                                          "https://sankoenerji.com.tr/" +
                                          images[
                                            (photoIndex + 1) % images.length
                                          ]
                                        }
                                        prevSrc={
                                          "https://sankoenerji.com.tr/" +
                                          images[
                                            (photoIndex + images.length - 1) %
                                              images.length
                                          ]
                                        }
                                        onCloseRequest={() => setIsOpen(false)}
                                        onMovePrevRequest={() =>
                                          imageChangeHandler(-1)
                                        }
                                        onMoveNextRequest={() =>
                                          imageChangeHandler(1)
                                        }
                                        animationDuration="100"
                                      />
                                    )}
                                  </>
                                ) : null}
                              </div>
                              <div className="wind-info-box">
                              {lang =="en" ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content_EN,
                                }}
                              ></div>
                              ) : (<div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content,
                                }}
                              ></div>)}
                              </div>
                            </div>
                          </>
                        );
                      })
                    : null
                )
              : null}
          </div>
        </>
        <>
          <div className="only-wind-container jeo">
            {currentTab == "Jeotermal" || currentTab == "Tüm Santraller"
              ? tabs.map((tab) => {
                  return tab.Name_TR === "Jeotermal"
                    ? tab.content.map((item) => {
                        return (
                          <>
                            <div
                              onClick={() => dropdownHandler(item.id, item)}
                              key={item.id}
                              className={
                                item.id == currentSubTabId
                                  ? "downable active jeo"
                                  : "downable"
                              }
                            >
                              <div className="elec-left-section">
                                <img src={jeopng} alt="sj" />
                                <h3>{lang =="en" ? item.Name_EN:item.Name_TR}</h3>
                              </div>
                              <button
                                onClick={(id) => dropdownHandler(id, item)}
                              >
                                <img
                                  className={
                                    item.id == currentSubTabId ? "" : "flat"
                                  }
                                  src={okcopy}
                                  alt="sj"
                                />
                              </button>
                            </div>
                            <div
                              className={
                                item.id == currentSubTabId
                                  ? "wind-info active jeo"
                                  : "wind-info"
                              }
                            >
                              <div className="img-slider">
                                {item.gallery ? (
                                  <>
                                    <Carousel
                                      pagination={false}
                                      focusOnSelect={true}
                                      breakPoints={breakPoints}
                                    >
                                      {item.gallery.map((img, i) => (
                                        <img
                                          onClick={() => imgOnClickHandler(i)}
                                          width="250px"
                                          src={
                                            "https://sankoenerji.com.tr/" +
                                            img.file_name.split(
                                              "/Uploads/"
                                            )[0] +
                                            "Uploads/thumbs/" +
                                            img.file_name.split("/Uploads/")[1]
                                          }
                                          alt={img.name}
                                        />
                                      ))}
                                    </Carousel>
                                    {isOpen && (
                                      <Lightbox
                                        mainSrc={
                                          "https://sankoenerji.com.tr/" +
                                          images[photoIndex]
                                        }
                                        nextSrc={
                                          "https://sankoenerji.com.tr/" +
                                          images[
                                            (photoIndex + 1) % images.length
                                          ]
                                        }
                                        prevSrc={
                                          "https://sankoenerji.com.tr/" +
                                          images[
                                            (photoIndex + images.length - 1) %
                                              images.length
                                          ]
                                        }
                                        onCloseRequest={() => setIsOpen(false)}
                                        onMovePrevRequest={() =>
                                          imageChangeHandler(-1)
                                        }
                                        onMoveNextRequest={() =>
                                          imageChangeHandler(1)
                                        }
                                        animationDuration="100"
                                      />
                                    )}
                                  </>
                                ) : null}
                              </div>
                              <div className="wind-info-box">
                              {lang =="en" ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content_EN,
                                }}
                              ></div>
                              ) : (<div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content,
                                }}
                              ></div>)}
                              </div>
                            </div>
                          </>
                        );
                      })
                    : null;
                })
              : null}
          </div>
        </>
        <>
          <div className="only-sun-container sun">
            {currentTab == "Güneş" || currentTab == "Tüm Santraller"
              ? tabs.map((tab) => {
                  return tab.Name_TR === "Güneş"
                    ? tab.content.map((item) => {
                        return (
                          <>
                            <div
                              onClick={() => dropdownHandler(item.id, item)}
                              key={item.id}
                              className={
                                item.id == currentSubTabId
                                  ? "downable active sun"
                                  : "downable"
                              }
                            >
                              <div className="elec-left-section">
                                <img src={gunespng} alt="sj" />
                                <h3>{lang =="en" ? item.Name_EN:item.Name_TR}</h3>
                              </div>
                              <button
                                onClick={(id) => dropdownHandler(id, item)}
                              >
                                <img
                                  className={
                                    item.id == currentSubTabId ? "" : "flat"
                                  }
                                  src={okcopy}
                                  alt="sj"
                                />
                              </button>
                            </div>
                            <div
                              className={
                                item.id == currentSubTabId
                                  ? "wind-info active sun"
                                  : "wind-info"
                              }
                            >
                              {item.gallery ? (
                                <div className="img-slider">
                                  <Carousel
                                    pagination={false}
                                    focusOnSelect={true}
                                    breakPoints={breakPoints}
                                  >
                                    {item.gallery.map((img, i) => (
                                      <img
                                        onClick={() => imgOnClickHandler(i)}
                                        width="250px"
                                        src={
                                          "https://sankoenerji.com.tr/" +
                                          img.file_name.split("/Uploads/")[0] +
                                          "Uploads/thumbs/" +
                                          img.file_name.split("/Uploads/")[1]
                                        }
                                        alt={img.name}
                                      />
                                    ))}
                                  </Carousel>
                                  {isOpen && (
                                    <Lightbox
                                      mainSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[photoIndex]
                                      }
                                      nextSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[(photoIndex + 1) % images.length]
                                      }
                                      prevSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[
                                          (photoIndex + images.length - 1) %
                                            images.length
                                        ]
                                      }
                                      onCloseRequest={() => setIsOpen(false)}
                                      onMovePrevRequest={() =>
                                        imageChangeHandler(-1)
                                      }
                                      onMoveNextRequest={() =>
                                        imageChangeHandler(1)
                                      }
                                      animationDuration="100"
                                    />
                                  )}
                                </div>
                              ) : null}
                            </div>
                            <div
                              className={
                                item.id == currentSubTabId
                                  ? "wind-info active"
                                  : "wind-info"
                              }
                            >
                              <div className="wind-info-box">
                              {lang =="en" ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content_EN,
                                }}
                              ></div>
                              ) : (<div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content,
                                }}
                              ></div>)}
                              </div>
                            </div>
                          </>
                        );
                      })
                    : null;
                })
              : null}
          </div>
        </>
        <>
          <div className="only-wind-container hibrit">
            {currentTab == "Hibrit" || currentTab == "Tüm Santraller"
              ? tabs.map((tab) => {
                  return tab.Name_TR === "Hibrit"
                    ? tab.content.map((item) => {
                        return (
                          <>
                            <div
                              onClick={() => dropdownHandler(item.id, item)}
                              key={item.id}
                              className={
                                item.id == currentSubTabId
                                  ? "downable active hibrit"
                                  : "downable"
                              }
                            >
                              <div className="elec-left-section">
                                <img src={hibritpng} alt="sj" />
                                <h3>{lang =="en" ? item.Name_EN:item.Name_TR}</h3>
                              </div>
                              <button
                                onClick={(id) => dropdownHandler(id, item)}
                              >
                                <img
                                  className={
                                    item.id == currentSubTabId ? "" : "flat"
                                  }
                                  src={okcopy}
                                  alt="sj"
                                />
                              </button>
                            </div>
                            <div
                              className={
                                item.id == currentSubTabId
                                  ? "wind-info active hibrit"
                                  : "wind-info"
                              }
                            >
                              {item.gallery ? (
                                <div className="img-slider">
                                  <Carousel
                                    pagination={false}
                                    focusOnSelect={true}
                                    breakPoints={breakPoints}
                                  >
                                    {item.gallery.map((img, i) => (
                                      <img
                                        onClick={() => imgOnClickHandler(i)}
                                        width="250px"
                                        src={
                                          "https://sankoenerji.com.tr/" +
                                          img.file_name.split("/Uploads/")[0] +
                                          "Uploads/thumbs/" +
                                          img.file_name.split("/Uploads/")[1]
                                        }
                                        alt={img.name}
                                      />
                                    ))}
                                  </Carousel>
                                  {isOpen && (
                                    <Lightbox
                                      mainSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[photoIndex]
                                      }
                                      nextSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[(photoIndex + 1) % images.length]
                                      }
                                      prevSrc={
                                        "https://sankoenerji.com.tr/" +
                                        images[
                                          (photoIndex + images.length - 1) %
                                            images.length
                                        ]
                                      }
                                      onCloseRequest={() => setIsOpen(false)}
                                      onMovePrevRequest={() =>
                                        imageChangeHandler(-1)
                                      }
                                      onMoveNextRequest={() =>
                                        imageChangeHandler(1)
                                      }
                                      animationDuration="100"
                                    />
                                  )}
                                </div>
                              ) : null}
                            </div>
                            <div
                              className={
                                item.id == currentSubTabId
                                  ? "wind-info active"
                                  : "wind-info"
                              }
                            >
                              <div className="wind-info-box">
                              {lang =="en" ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content_EN,
                                }}
                              ></div>
                              ) : (<div
                                dangerouslySetInnerHTML={{
                                  __html: item.Content,
                                }}
                              ></div>)}
                              </div>
                            </div>
                          </>
                        );
                      })
                    : null;
                })
              : null}
          </div>
        </>
      </div>
    </>
  );
};
export default SantralPage;
